import styled from "styled-components";

const InputContainer = styled.div`
  border: 1px solid black;
`;


interface Text {
  
    text: string,
    size: any,
    weight: any,
    style?: {},
    align?: "left" | "center" | "right"
}

const Text = ({ text, size, weight, style, align }: Text) => {

    const defaultStyles = {
        marginBottom: 0,
        fontSize: size,
        fontWeight: weight == 600 ? 'bold' : 'normal',
        textAlign: align
    };


    const mergedStyles = { ...defaultStyles, ...style };


    return (
        <p style={mergedStyles}>{text}</p>
       

    )
}

export default Text;